var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from '@app/Components/Modal/Modal';
import { MeetingContent } from './MeetingContent/MeetingContent';
export var Meeting = /** @class */ (function (_super) {
    __extends(Meeting, _super);
    function Meeting() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meeting.prototype.render = function () {
        var _a;
        var projectId = (_a = this.props, _a.projectId), gateId = _a.gateId, gateForecastOrActualDate = _a.gateForecastOrActualDate, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted, onToggle = _a.onToggle;
        return (React.createElement(Modal, { headerTitle: "Meeting", maxWidth: '1200px', isOpen: true, toggle: function () { return onToggle(); }, footerbuttons: this._getFooterButtons() },
            React.createElement(MeetingContent, { projectId: projectId, gateId: gateId, gateForecastOrActualDate: gateForecastOrActualDate, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted })));
    };
    Meeting.prototype._getFooterButtons = function () {
        return [
            {
                onClick: this.props.onToggle,
                title: 'Close'
            }
        ];
    };
    Meeting = __decorate([
        observer
    ], Meeting);
    return Meeting;
}(React.Component));
